// imports
import Component from 'minsky-kit/js/components/Component';
import { LIBMGR } from 'minsky-kit/js/managers/LibManager';
import BookerOverlay from './BookerOverlay';

// prep lib loading
LIBMGR.add({
    tableBooker: {
        js: '//reservations.tablebooker.com/tbkr-widget-import.min.js',
    },
});

// private statics

// class definition
export default class ReservationView extends Component {
    // constructor
    constructor (args = {}, objectName = 'ReservationView') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);

        // set properties
        this._$links = this.$el.querySelectorAll('.store-small-t__link');

        // load library
        LIBMGR.load(['tableBooker'])
            .then(() => {
                this.log('table booker loaded');

                // add listeners
                this._$links.forEach(($l) => {
                    $l.addEventListener('click', this.blm.addOnce('onLinkClick', onLinkClick));
                });
            })
            .catch((e) => {
                this.log('error', 'Failed to load Table booker lib', e);
            });
    }

    // methods
    destroy () {
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
function openBookerOverlay (id) {
    const bookerOverlay = new BookerOverlay({ id });
    bookerOverlay.show();
    bookerOverlay.once('hidden', destroyBookerOverlay);
}

function destroyBookerOverlay (e) {
    e.preventAllDefaults();
    e.currentTarget.destroy();
}

function onLinkClick (e) {
    e.preventDefault();
    openBookerOverlay.call(this, e.currentTarget.dataset.tableBookerId);
}
